import { Grid, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import React, { FunctionComponent } from "react";

interface OwnProps {
    parentHeightPx: number;
    errorText?: string;
}

type Props = OwnProps;

const WidgetError: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = (props) => {
    return (
        <div style={{ position: "relative", top: `20%` }}>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs={12}>
                    <ErrorOutlineIcon
                        sx={{
                            color: "error.main",
                            opacity: 0.35,
                            fontSize: `${props.parentHeightPx * 0.42}px`,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        sx={{
                            opacity: 0.25,
                            color: "#1F1F1F",
                            fontSize:
                                props.parentHeightPx > 450 ? "24px" : "18px",
                            fontWeight: "bold",
                            letterSpacing: 0,
                            lineHeight: "20px",
                        }}
                    >
                        {props.errorText}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

export default WidgetError;
